export const queryKeys = {
  state: ["state"] as const,
  stateSummaries: (tenantId?: string) => ["state", "summaries", tenantId] as const,
  tenants: () => ["tenants"] as const,
  tenant: (id: string) => ["tenants", id] as const,
  tenantAgents: (tenantId: string) => ["tenants", tenantId, "agents"] as const,
  agent: (tenantId: string, agentId: string) =>
    ["tenants", tenantId, "agents", agentId] as const,
  conversationTaskFlows: (tenantId: string, sessionKey: string) =>
    ["tenants", tenantId, "tasks", "flows", sessionKey] as const,
  conversationTaskRuns: (tenantId: string, sessionKey: string) =>
    ["tenants", tenantId, "tasks", "runs", sessionKey] as const,
  tenantRuntimeTarget: (tenantId: string) =>
    ["tenants", tenantId, "runtimeTarget"] as const,
  tenantChannelConnections: (tenantId: string) =>
    ["tenants", tenantId, "channelConnections"] as const,
  tenantChannelDeployments: (tenantId: string) =>
    ["tenants", tenantId, "channelDeployments"] as const,
  tenantConnectorInstalls: (tenantId: string) =>
    ["tenants", tenantId, "connectorInstalls"] as const,
  providerDescriptors: (tenantId?: string) => ["providerDescriptors", tenantId ?? "global"] as const,
  tenantCapabilityBindings: (tenantId: string) =>
    ["tenants", tenantId, "capabilityBindings"] as const,
  tenantCapabilityTargets: (tenantId: string) =>
    ["tenants", tenantId, "capabilityTargets"] as const,
  tenantWorkflowPolicies: (tenantId: string) =>
    ["tenants", tenantId, "workflowPolicies"] as const,
  automations: (tenantId: string) =>
    ["tenants", tenantId, "automations"] as const,
  automation: (tenantId: string, automationId: string) =>
    ["tenants", tenantId, "automations", automationId] as const,
  automationRuns: (tenantId: string, automationId: string) =>
    ["tenants", tenantId, "automations", automationId, "runs"] as const,
  automationInbox: (tenantId: string) =>
    ["tenants", tenantId, "automations", "inbox"] as const,
  automationInboxDetail: (tenantId: string, notificationId: string) =>
    ["tenants", tenantId, "automations", "inbox", notificationId] as const,
  tenantIdentityRules: (tenantId: string) =>
    ["tenants", tenantId, "identityRules"] as const,
  identityRule: (tenantId: string, channel: string, userId: string) =>
    ["tenants", tenantId, "identityRules", channel, userId] as const,
  tenantDirectoryUsers: (tenantId: string) =>
    ["tenants", tenantId, "directoryUsers"] as const,
  tenantAiProviderConnections: (tenantId: string) =>
    ["tenants", tenantId, "aiProviderConnections"] as const,
  pluginManifests: (pluginId?: string) => ["plugins", "manifests", pluginId ?? "all"] as const,
  tenantPluginConfig: (tenantId: string, pluginId: string) =>
    ["tenants", tenantId, "plugins", pluginId, "config"] as const,
  tenantPluginCredential: (tenantId: string, pluginId: string, credentialKey: string) =>
    ["tenants", tenantId, "plugins", pluginId, "credentials", credentialKey] as const,
  providerOAuthStatus: (tenantId: string, providerId: string, transactionId: string) =>
    ["tenants", tenantId, "providerOAuth", providerId, transactionId] as const,
  tenantModelCatalog: (tenantId: string, provider?: string) =>
    ["tenants", tenantId, "modelCatalog", provider ?? "all"] as const,
  providerIdentityLinks: (tenantId: string) =>
    ["tenants", tenantId, "providerIdentityLinks"] as const,
  workflowDefinitions: () => ["workflowDefinitions"] as const,
  executions: (filters?: { tenantId?: string }) => ["executions", filters] as const,
  execution: (id: string) => ["executions", "detail", id] as const,
  auditEvents: (filters?: {
    tenantId?: string;
    executionId?: string;
    workflowKey?: string;
    actorId?: string;
    resourceType?: string;
    resourceId?: string;
    limit?: number;
  }) =>
    ["audit-events", filters] as const,
  liveSnapshot: (tenantId: string) => ["live-snapshot", tenantId] as const,
  agentAccessPolicy: (tenantId: string, agentId: string) =>
    ["tenants", tenantId, "agents", agentId, "accessPolicy"] as const,
} as const;
